import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import { LocalPharmacy as SupplementIcon } from "@mui/icons-material";
import EmptyStateCard from "../../../../components/EmptyStateCard";
import useEvents from "../../../../hooks/useEvents";

type EmptySupplementsProps = {
  onAddSupplement: () => void;
};

const EmptySupplements = ({ onAddSupplement }: EmptySupplementsProps) => {
  const events = useEvents();
  
  return (
    <Box data-testid="EmptySupplementsView" style={{ margin: 24 }}>
      <EmptyStateCard
        text="Build your supplement database to recommend products that support your clients' health and fitness goals."
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500, alignItems: "center" }} spacing={2}>
          <Typography style={{ textAlign: "center", marginBottom: 16 }}>
            Add supplements with descriptions and sales links. These will be available 
            to recommend to clients in their summary profiles and nutrition plans.
          </Typography>
          
          <StandardButton
            data-testid="EmptySupplementsView-Button"
            variant="primary"
            startIcon={<SupplementIcon />}
            onClick={() => {
              onAddSupplement();
              events.logButtonClick({
                buttonName: "Add Your First Supplement",
                pageName: "Nutrition",
                tabName: "Supplements",
              });
            }}
            style={{ fontSize: 16 }}
          >
            Add Your First Supplement
          </StandardButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptySupplements;